// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__12VHx","nonPrintable":"styles_nonPrintable__Ykdni","pill":"styles_pill__UjPop"};